import { render, staticRenderFns } from "./BuildingUserCreate.vue?vue&type=template&id=9b43f906"
import script from "./BuildingUserCreate.vue?vue&type=script&lang=js"
export * from "./BuildingUserCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports